import CloseIcon from "@mui/icons-material/Close";
import { Divider, Grid, IconButton, InputAdornment } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as constants from "../../constants";
import CustomAutocomplete from '../../shared/AutoComplete';
import ContainedButton from '../../shared/Button/CustomContainedButton';
import OutlinedButton from '../../shared/Button/customOutlinedButton';
import CustomTextField from '../../shared/CustomTextFeild';
import { RootState } from '../../store/store';
import { getEntityNamesByPId } from '../fiscalUpgrade/services/MonthlyCalculations/monthlyServices';
import { notifyUser } from '../fiscalUpgrade/Utils/notifyUser';
type CloseCreditLinePayload = {
  creditId: number;
  principal: number;
  interest: number;
  totalAmount: number;
  creditLineDescription: string;
  loanAccount: any;
};
type PopUpProps = {
  open: boolean;
  principal: number;
  interest: number;
  totalAmount: number;
  handleClose: () => void;
  saveChanges: (data: CloseCreditLinePayload) => void;
  message: string;
  popupTitle: string;
  CreditId: number;
  disabled?: boolean
};

export default function CloseCreditLine(props: PopUpProps) {
  const { open, principal, interest, totalAmount, handleClose, saveChanges, message, popupTitle, CreditId, disabled } = props;
  const { t } = useTranslation();
  const userInfo = useSelector((state: RootState) => state.auth);
  const translate = t as (key: string) => string;

  const [selectedLoanAccountName, setSelectedLoanAccountName] = useState(null);
  const [loanAccountNameArray, setLoanAccountNameArray] = useState<any>([]);
  useEffect(() => {
    getEntityListByPid(userInfo?.defaultParticipantId, "Loan", userInfo?.clientId);
  }, [CreditId]);

  async function getEntityListByPid(pId: 0, entityName: string, clientId: number) {
    try {
      const response = await getEntityNamesByPId(pId, entityName, clientId);
      if (response.status == constants.STATUS_CODES.SUCCESS) {
        const entityData = response.data.data;
        setLoanAccountNameArray(entityData);
      } else {
        notifyUser(response?.data?.message, 'error', popupTitle);
      }
    } catch (error: any) {
      notifyUser(error.response?.data?.message || translate("anUnexpectedError"), 'error', popupTitle);
    }
  }
  const toNumber = (val: string | number): number => {
    if (!val) return 0;
    return Number(String(val).replace(/,/g, ""));
  };

  const handleSave = () => {
    if (!selectedLoanAccountName) return;

    saveChanges({
      creditId: CreditId,
      principal: toNumber(principal),
      interest: toNumber(interest),
      totalAmount: toNumber(totalAmount),
      creditLineDescription: "",
      loanAccount: selectedLoanAccountName,
    });
  };
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { minWidth: '25%' } }}
    >
      <DialogTitle sx={{
        backgroundColor: "#059ca9",
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 10px'
      }}>
        {popupTitle}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: "white",
            padding: '0px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ paddingTop: '20px' }}>
        <DialogContentText
          sx={{
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            fontSize: '1rem'
          }}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={5}  >
              <CustomTextField
                labelText={translate('totalAmount')}
                placeholder="0.00"
                size="small"
                readOnly
                value={totalAmount}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                }}

                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={7} sx={{ mt: 5 }}>
              ({translate('principal')}&nbsp;$ {principal ? principal : "0.00"}
              &nbsp; &   {translate('interest')}&nbsp;$  {interest ? interest : "0.00"})


            </Grid>
          </Grid>
          <CustomAutocomplete
            labelText={message}
            required
            sx={{ width: '100%', mt: 1 }}
            options={loanAccountNameArray || []}
            value={selectedLoanAccountName}
            onChange={(event, newValue) => {
              if (newValue) setSelectedLoanAccountName(newValue);
            }}
            onBlur={() => {
              if (!selectedLoanAccountName) {
                setSelectedLoanAccountName(null);
              }
            }}
            getOptionLabel={(option) =>
              option.id === 0 || option.id === 1 ? option.name : `${option.id}-${option.name}`
            }
            label={translate('loanAccountName')}
            placeholder={translate('loanAccountName')}
          />



        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <DialogActions sx={{ padding: '0px' }}>
          <ContainedButton onClick={handleSave} autoFocus disabled={!selectedLoanAccountName}  >
            {translate('yes')}
          </ContainedButton>
          <OutlinedButton onClick={handleClose}>
            {translate('no')}
          </OutlinedButton>

        </DialogActions>

      </DialogActions>
    </Dialog >
  );
}
